import { render, staticRenderFns } from "./rankingList.vue?vue&type=template&id=499a8391"
import script from "./rankingList.vue?vue&type=script&lang=js"
export * from "./rankingList.vue?vue&type=script&lang=js"
import style0 from "./rankingList.vue?vue&type=style&index=0&id=499a8391&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports